import { useMutation as c } from "@tanstack/react-query";
import { useAuthStore as a, selectCurrentUserId as f, selectCurrentUserOnboarding as b, updateCurrentUser as l } from "@waitroom/auth";
import { userApiService as U } from "@waitroom/common-api";
import { useState as C } from "react";
import { config as I } from "../config/index.es.js";
const d = (e, n = !1) => Object.keys(e).reduce((o, i) => ({ ...o, [i]: n }), {}), j = ({
  onSuccess: e
} = {}) => {
  var s;
  const n = a(f) || "", o = a(b), [i, u] = C({}), m = c({
    mutationFn: (t) => (u((r) => ({ ...r, ...d(t, !0) })), U.update(n, {
      data: {
        onboarding: {
          ...o,
          ...t
        }
      }
    })),
    onSuccess: (t) => {
      const { data: r } = t.data || {};
      r != null && r.user && (e == null || e(t), l(r.user));
    },
    onError: (s = I.logger) == null ? void 0 : s.report,
    onSettled: (t, r, g) => {
      u((p) => ({
        ...p,
        ...d(g)
      }));
    }
  });
  return {
    isLoading: i,
    mutation: m,
    onboarding: o
  };
};
export {
  j as useUpdateOnboarding
};
